import { CSSProperties } from "react";

export const style: CSSProperties = {
  marginTop: 2,
  marginBottom: 2,
};
